import React from 'react';

function ResponsibleDisclosureSEO() {
  return <meta name="description" content="Responsible Disclosure & Bug Bounty Policy - Closure" />;
}

export default ResponsibleDisclosureSEO;

